<template>
  <table class="table table-hover table-sm">
    <tr>
      <th>Zeit</th>
      <th>Status</th>
    </tr>
    <tr v-for="hour in relevantHours" :key="hour.hour" class="text-white"
        @click="$emit('hourclick', hour.hour)">
      <td :class="cellClass(hour, 0)">{{ hour.hour }}:00</td>
      <td class="w-100" :class="cellClass(hour, 1)">{{ hour.translatedReason }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  props: {
    date: Object,
    highlightStartHour: Number,
    highlightStopHour: Number,
  },
  data() {
    return {
      blockedTimes: []
    }
  },
  computed: {
    relevantHours() {
      if (!this.hours)
        return []
      return this.hours.filter(h => h.hour >= 8)
    }
  },
  asyncComputed: {
    hours() {
      if (!this.date)
        return []
      return this.$api.get(`/calendar/${this.date.year}/${this.date.month}/${this.date.day}/blocked-times`)
          .then(response => {
            const hours = []
            for (let i = 0; i < 24; i++)
              hours.push({
                hour: i,
                blocked: false
              })
            response.data.forEach(blockedTime => {
              const {startHour, endHourExclusive} = this.toHourRange(blockedTime)
              for (let h = startHour; h < endHourExclusive; h++) {
                hours[h] = {
                  hour: h,
                  blocked: true,
                  reason: blockedTime.reason,
                  translatedReason: this.translatedReason(blockedTime.reason)
                }
              }
            })
            return hours
          })
    }
  },
  methods: {
    /**
     * Wandelt einen BlockedTime mit `startTime`/`endTime` (LocalTime) in einen
     * Stundenbereich um. Das Backend liefert Halbschluss-Intervalle [start, end):
     *   - startHour: angefangene Startstunde
     *   - endHourExclusive: Stunde, ab der wieder frei ist
     *
     * Liegt endTime exakt auf einer vollen Stunde (z. B. 14:00), ist diese Stunde
     * bereits frei. Liegt endTime mitten in einer Stunde (z. B. 14:30), gilt 14
     * als (teilweise) blockiert und wird mitgezählt.
     */
    toHourRange(blockedTime) {
      const start = this.parseLocalTime(blockedTime.startTime)
      const end = this.parseLocalTime(blockedTime.endTime)
      const endHourExclusive = end.minute > 0 ? end.hour + 1 : end.hour
      return {startHour: start.hour, endHourExclusive}
    },
    /**
     * Akzeptiert sowohl die String-Form ("HH:mm:ss" oder "HH:mm") als auch die
     * Array-Form ([hour, minute, ...]), in der Jackson LocalTime ohne
     * WRITE_DATES_AS_TIMESTAMPS=false serialisiert.
     */
    parseLocalTime(value) {
      if (Array.isArray(value)) {
        return {hour: value[0] ?? 0, minute: value[1] ?? 0}
      }
      if (typeof value === 'string') {
        const parts = value.split(':')
        return {hour: parseInt(parts[0], 10), minute: parseInt(parts[1] || '0', 10)}
      }
      return {hour: 0, minute: 0}
    },
    translatedReason(reason) {
      if (!reason)
        return 'frei'
      if (reason === 'Reservation')
        return 'Reservierung'
      if (reason === 'NotReservable')
        return 'nicht reservierbar'
      if (reason === 'ReservationMaintenance')
        return 'Nachbereitung'
      if (reason === 'Closed')
        return 'Blockiert'
    },
    cellClass(hour) {
      // highlight
      if (hour.hour >= this.highlightStartHour && hour.hour < this.highlightStopHour)
        return 'bg-primary'
      // background
      if (hour.reason === 'ReservationMaintenance' || hour.hour === this.highlightStopHour)
        return 'bg-warning'
      if (hour.reason === 'NotReservable')
        return 'bg-info'
      if (hour.reason === 'Reservation' || hour.reason === 'Closed')
        return 'bg-danger'
      return 'bg-success'
    }
  }

}
</script>